import {client as http, axiosInstance} from "@/http_client";
import async from "async";

export default {
    state: {
        enrollments: null,
        classicEnrollments: null
    },
    getters: {
        enrollments: state => state.enrollments,
        classicEnrollments: state => state.classicEnrollments
    },
    mutations: {},
    actions: {
        getEnrollments({state}) {
            return new Promise((resolve, reject) => {
                let enrollments;
                let classicEnrollments;

                async.series([
                    (cb) => {
                        http.get('app/enrollments/', {force: true}).then(response => {
                            enrollments = response.data.enrollments;
                            classicEnrollments = response.data.classicEnrollments;
                            cb()
                        }).catch(err => {
                            cb(err)
                        });
                    },
                ], (err) => {
                    if (err) {
                        console.log('err', err);
                        reject(err.response);
                        return;
                    }

                    state.enrollments = enrollments;
                    state.classicEnrollments = classicEnrollments;
                    resolve(enrollments);
                });
            });
        },
    }
};
